// extracted by mini-css-extract-plugin
export default {"newsList":"index_newsList_aQ-2g","newsListPT450":"index_newsListPT450_tK2uE","more":"index_more_XYbLz","noMore":"index_noMore_lf2NA"};